module.exports = __webpack_public_path__ + "static/Portrait-LightItalic-d7308e66d81b60ca0eaf6e5b1a2842e7.woff";